import service from '../service/leftService'

const actions = {
  showPointValueDialog: function ({ commit }, statusObj) {
    let obj = {
      type: statusObj.type,
      isEdit: statusObj.isEdit
    }
    commit('OPEN_POINT_DIALOG', obj)
    commit('POINT_SHOW', true)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/actions.js